import React, { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "../components/Footer";
import "./style.css";
import "./responsive.css";
import BLogList from "./BlogList";

export default function Blogs(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth > 425);
  let navigate = useNavigate();
  const aboutUsRef = useRef(null);
  const feedbackRef = useRef(null);
  const homeRef = useRef(null);

  const scrollToAboutUs = () => {
    if (aboutUsRef.current) {
      aboutUsRef.current.scrollIntoView({ behavior: "smooth" });
      console.log("aboutref", aboutUsRef);
    }
  };

  const scrollToFeedback = () => {
    if (feedbackRef.current) {
      feedbackRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToHome = () => {
    if (homeRef.current) {
      homeRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.addEventListener(
      "resize",
      () => {
        const ismobile = window.innerWidth > 425;
        if (ismobile !== isMobile) setIsMobile(ismobile);
      },
      false
    );
  }, [isMobile]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header
        scrollToAboutUs={scrollToAboutUs}
        fixed
        scrollToHome={scrollToHome}
        scrollToFeedback={scrollToFeedback}
        aboutUsRef={aboutUsRef}
        feedbackRef={feedbackRef}
      />

      <main className="flex-grow">
        <div
          className="w-full px-4 pb-12 pt-20 sm:pb-16 sm:pt-24"
          ref={homeRef}
        >
          <div className="w-full">
            <BLogList />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
